// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".compiled.js?v=" + "70d6c0a4fb4a225a65bf" + "";
};